import { roundValue, safeParseFloat } from "lib/number";
import { getChildrenTotalCost } from "../column-formula/total-cost";
import { getChildrenTotalRetail } from "../column-formula/total-retail";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

export const IMU_PERCENTAGE = ({ factoryOptions, getterParams }) => {
    const totalCost = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenTotalCost` will count nested children
                if (rowNode.level === 0) {
                    totalUnits += getChildrenTotalCost(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalUnits;
        },
        getterParams,
        MetricsKind.TOTAL_COST
    );

    const totalRetail = referenceMetricValueOrCompute(
        () => {
            let totalRetail = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenTotalRetail` will count nested children
                if (rowNode.level === 0) {
                    totalRetail += getChildrenTotalRetail(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalRetail;
        },
        getterParams,
        MetricsKind.TOTAL_RETAIL
    );

    const imuPercentage = safeParseFloat((totalRetail - totalCost) / totalRetail, 0) * 100;
    const roundedValue = roundValue(imuPercentage, 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
